
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router";
import { env } from "../config";

function CloudStackStructuredCards(props: any) {
    const { description, imagePosition, altText } = props;
    const { ref, inView } = useInView({
        // triggerOnce: true,
        threshold: 0,
    });
    let navigate = useNavigate();

    const buttonLink = description?.ButtonText?.includes("#")
        ? description?.ButtonText?.split("#")
        : null;

    return (
        <div className="bg-[white] font-custom">
            <div className="px-5 py-7 bg-[#12121] relative lg:px-10 text-black-75 xl:px-20 lg:py-20  max-w-screen-2xl lg:mx-auto text-black-75 grid lg:grid-cols-2 gap-10">

                <div ref={ref} className=" flex flex-col justify-center">

                    <div className="rounded-full py-1.5 px-4 bg-white text-sm border border-[#8A8A8A] w-max mb-3 text-[#F7941E]">
                        How it works
                    </div>
                    <div
                        className={` text-2xl md:text-4xl lg:text-5xl   font-custom font-bold`}
                    >
                        <div
                            dangerouslySetInnerHTML={{
                                __html: description?.Title1,
                            }}
                        />
                        {/* {description?.Title1} */}
                    </div>
                    <div
                        className={`text-2xl md:text-4xl lg:text-5xl md:mt-3  font-custom font-bold`}
                    >
                        {inView ? (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: description?.Title2,
                                }}
                            />
                        ) : (
                            <div
                                className={` text-2xl md:text-4xl lg:text-5xl  font-custom font-bold`}
                            >
                                Development
                            </div>
                        )}
                    </div>

                    <div className={`lg:text-lg md:text-base  font-normal mt-3 pt-3 mb-4`}>
                        {description?.Description1}
                    </div>
                    <div className={`lg:text-lg md:text-base   font-normal pt-3`}>
                        {description?.Description2}
                    </div>

                    {buttonLink ? (
                        <button
                            onClick={() => {
                                buttonLink[1]?.includes("https")
                                    ? window.open(buttonLink[1], "_blank", "noopener,noreferrer")
                                    : navigate(buttonLink);
                            }}
                            className=" bg-[#616161] text-white   border border-[#616161] hover:bg-white hover:text-[#616161] hover:border hover:border-[#616161] rounded-[50px] w-max px-4 py-2 my-6"
                        >
                            {buttonLink[0]}
                        </button>
                    ) : description?.ButtonText ? (
                        <button
                            onClick={() => {
                                navigate("/contact-us");
                            }}
                            className=" bg-[#F7941E] text-white border border-[#616161] hover:bg-white hover:text-[#F7941E] duration-300 hover:border hover:border-[#F7941E] rounded-[50px] w-max px-4 py-2 my-6"
                        >
                            {description?.ButtonText}
                        </button>
                    ) : null}
                    {description?.introCards?.map((node: any, index: number) => {
                        return (
                            <div
                                key={index + node?.Title}
                                data-aos="fade-left"
                                data-aos-delay={`${index === 0 ? 150 : index * 150}`}
                                className={`  bg-white  flex items-start `}
                            >
                                <img
                                    alt={`decoration`}
                                    loading="lazy"
                                    className={` z-[100] mr-5`}
                                    src={`${env}${node?.Image?.data?.attributes?.url}`}
                                />{" "}

                                <div>
                                    <div className="font-bold font-custom  md:text-base text-base   pb-1">
                                        {node?.Title}
                                    </div>
                                    <div className="font-custom md:text-base text-base ">
                                        {node?.Description}
                                    </div>
                                </div>

                            </div>
                        );
                    })}
                </div>

                <img
                    alt={altText}
                    loading="lazy"
                    className={`${imagePosition} z-[100] m-auto -order-3 lg:order-1`}
                    src={`${env}${description?.Image?.data?.attributes?.url}`}
                />{" "}

            </div>

        </div>

    );
}

export default CloudStackStructuredCards;
